import { SupportedLocale as SupportedLocaleType } from 'generated/graphql';
import {
  getSupportedLocaleMetadata,
  SupportedLocale,
} from '@sz/l10n';
import { TSelectOption } from '@spotted-zebra-uk/ui-components';

export const initialLanguageOption: TSelectOption<SupportedLocaleType> = {
  label: getSupportedLocaleMetadata(SupportedLocale.ENGLISH).name.english,
  value: SupportedLocaleType.English,
};
